var _rect, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7,
    fill: "#4B9BF5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 18,
    height: 18,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7cbdb6806086dca226a9df4391d48d2b.svg";
export { ForwardRef as ReactComponent };